import React from "react";
import {iconService} from "../../jwt/_services/landings/iconService";

export const iconProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await iconService.getOptions( customFilter );

        return listItems.map( ({id, code, name}) => ({
                id,
                value: `${code}${name ? ` - ${name}` : ''}`,
                label: <label>{ `${code}${name ? ` - ${name}` : ''}` }</label>
            })
        );
    } catch (error) {
        console.log(error.message)
    }
}